import Ajax from '../common/ajax'
import Tool from "../common/tool";

export default {
  model: 'examiner',
  getTaskPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/taskPage`, queryParam)
  },
  setupTask (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/setupTask`, queryParam)
  },
  getTaskInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/taskInfo/${id}`)
  },
  pushTask (id) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/changeTask/${id}`)
  },
  del (id) {
    return Ajax.del(`/api/gradeMaster/v1/${this.model}/deleteTask/${id}`)
  },
  getReviewPage  (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/examinerReviewPage`, queryParam)
  },
  async getTreeData () {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/specialtyTree`)
    // let treeData =
    // Tool.walkTree(treeData, (node) => {
    //   if (Tool.isNull(node.child)) {
    //     delete node.children
    //   }
    // })
    // return treeData
  },
  delSpecialty (id) {
    return Ajax.del(`/api/gradeMaster/v1/${this.model}/deleteSpecialty/${id}`)
  },
  addSpecialty (data={}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/setupSpecialty`,data)
  },
  getaskList (data={}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/taskList`,data)
  },
  getAreaList(type) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/areaList/${type}`)
  },
  getAgentArr() {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/getAgent`)
  },
  getApplyDetail (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/examinerReviewInfo/${id}`)
  },
  commitApply (data={}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/examinerReview`,data)
  },
  examinerExport (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/exportExaminerInfo`,data)
  }
  // async getAgentTreeData (data = {}) {
  //   let agentList = await Ajax.post(`/api/gradeMaster/proxy/v1/agent/list`, data)
  //   let set1 = new Set()
  //   let set2 = new Set()
  //   let listAll = []
  //   for (let i in agentList) {
  //     let agent = agentList[i]
  //     if (!set1.has(agent.parentAddress)) {
  //       listAll.push({ value: agent.parentAddress, label: agent.parentAddressInfo, parentId: null })
  //       set1.add(agent.parentAddress)
  //     }
  //     if (!set2.has(agent.address)) {
  //       listAll.push({ value: agent.address, label: agent.addressInfo, parentId: agent.parentAddress })
  //       set2.add(agent.address)
  //     }
  //     listAll.push({ value: agent.agentId, label: agent.agentName, parentId: agent.address })
  //   }
  //   let tree = Tool.toTree(listAll, 'value', 'parentId', null, 'children')
  //   return tree
  // }
}
